import type { TimelineEntry } from '../types/content';

/** Documented milestones, by completion year as recorded in the company profile. */
export const companyTimeline: TimelineEntry[] = [
  { year: '2007', items: ['Liftoff Investments (Pty) Ltd incorporated in Botswana (May 2007)'] },
  { year: '2013', items: ['Phakalane roads with double seal surfacing for Dangab Property Development'] },
  { year: '2014', items: ['BMC Lobatse workshop, change rooms and boundary wall', 'SOS Francistown renovations'] },
  { year: '2015', items: ['Setlhoa Village reticulation and road works'] },
  { year: '2016', items: ['Kanye – Mheelo ward water reticulation and gravel roads', 'Bowasetso Park Phase 1'] },
  {
    year: '2017',
    items: [
      'Serowe sewer effluent irrigation scheme',
      'Kanye Prison facilities maintenance',
      'Lobatse railway station waiting rooms and ticket office',
      'Matsiloje 500 m³ steel storage tank',
    ],
  },
  {
    year: '2018',
    items: ['OM1 tailings conveyor disposal, Orapa', 'S&SD resource centre earthworks, Orapa', 'Airport Junction Mall earthworks'],
  },
  { year: '2019', items: ['Letlhakane Mine tailings infrastructure disposal', 'Tawana Preschool classroom block'] },
  { year: '2020', items: ['Mahalapye Prison staff housing refurbishment', 'Orapa FRD site maintenance'] },
  { year: '2021', items: ['Orapa Mine water reticulation upgrade', 'Orapa No. 2 Plant tailings conveyor'] },
  { year: '2023', items: ['Mphuthe CJSS: Practical Completion Certificate issued'] },
  {
    year: 'Current',
    items: [
      'A3 Francistown–Nata road works through joint ventures',
      'Goodhope vacuum sewer refurbishment (WUC)',
      'Gaborone wastewater pump stations (WUC)',
      'Khoemacau boxcut slope maintenance',
    ],
  },
];
